import VanillaTilt from "vanilla-tilt";
import initSr from "./js/sr";

initSr();

VanillaTilt.init(document.querySelectorAll(".project-wrapper__image .thumbnail"), {
  max: 3,
});
